import analytics, { GA_CATEGORIES } from 'lib/client/analytics/analytics';

export enum ShowStepEventLabel {
  Step1ClaimantInformation = 'Step 1: Claimant Information',
  Step2ReportType = 'Step 2: Report Type',
  Step3ContentInformation = 'Step 3: Content Information',
  Step4EmailVerification = 'Step 4: Email Verification',
  Step5ClaimSubmitted = 'Step 5: Claim Submitted',
}

class ReportContentAnalyticsUtils {
  trackShowStepEvent = (showStepEventLabel: ShowStepEventLabel) => {
    analytics.trackEvent({
      category: GA_CATEGORIES.REPORT_CONTENT,
      action: 'Show Step',
      label: showStepEventLabel,
    });
  };
}

export default new ReportContentAnalyticsUtils();
